import { useEffect, useState } from 'react'
import PecasAcervo from '@services/pecasAcervo'

export default function useAcervoCatalog(area, revision = 0) {
  const [catalog, setCatalog] = useState({ areas: [], acoes: [], acoesCanonicas: [] })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  useEffect(() => {
    const controller = new AbortController()
    setError('')
    setLoading(true)
    setCatalog((current) => ({ ...current, acoes: [], acoesCanonicas: [] }))
    PecasAcervo.catalog(area, controller.signal).then((result) => {
      if (controller.signal.aborted) return
      if (result.success) setCatalog({ areas: result.data.areas || [], acoes: result.data.acoes || [], acoesCanonicas: result.data.acoesCanonicas || [] })
      else setError(result.error || 'Não foi possível carregar as áreas e ações.')
    }).catch(() => {
      if (!controller.signal.aborted) setError('Não foi possível carregar as áreas e ações.')
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false)
    })
    return () => controller.abort()
  }, [area, revision])
  return { ...catalog, error, loading }
}
